module.exports = __webpack_public_path__ + "img/left2.05102bb3.png";